import { gql, useMutation } from '@apollo/client'
import {
  MutationUserCommentCreateArgs,
  MutationUserCommentCreatePayload,
} from 'src/generated'

const MUTATION_USER_COMMENT_CREATE = gql`
  mutation UserCommentCreate($input: MutationUserCommentCreateInput!) {
    userCommentCreate(input: $input) {
      userComment {
        id
      }
    }
  }
`

const useUserCommentCreateMutation = () => {
  return useMutation<
    { userCommentCreate: MutationUserCommentCreatePayload },
    MutationUserCommentCreateArgs
  >(MUTATION_USER_COMMENT_CREATE)
}

export default useUserCommentCreateMutation
